import React from 'react'
import LoyaltyCouponsGrid from './LoyaltyCouponsGrid'

export default function LoyaltyCouponsPage () {
  return (
    <div>
      <LoyaltyCouponsGrid />
    </div>
  )
}
